{
    "accentColor": {
        "type": "color"
    },
    "additiveSymbols": {},
    "alignContent": {
        "type": "list",
        "values": [
            "start",
            "end",
            "flex-start",
            "flex-end",
            "center",
            "normal",
            "baseline",
            "first baseline",
            "last baseline",
            "space-between",
            "space-around",
            "space-evenly",
            "stretch",
            "safe",
            "unsafe"
        ]
    },
    "alignItems": {
        "type": "list",
        "values": [
            "start",
            "end",
            "flex-start",
            "flex-end",
            "self-start",
            "self-end",
            "center",
            "normal",
            "baseline",
            "first baseline",
            "last baseline",
            "space-between",
            "space-around",
            "space-evenly",
            "stretch",
            "safe",
            "unsafe"
        ]
    },
    "alignSelf": {
        "type": "list",
        "values": [
            "start",
            "end",
            "flex-start",
            "flex-end",
            "self-start",
            "self-end",
            "center",
            "normal",
            "baseline",
            "first baseline",
            "last baseline",
            "space-between",
            "space-around",
            "space-evenly",
            "stretch",
            "safe",
            "unsafe"
        ]
    },
    "alignmentBaseline": {},
    "all": {},
    "animation": {},
    "animationDelay": {
        "type": "time"
    },
    "animationDirection": {},
    "animationDuration": {
        "type": "time"
    },
    "animationFillMode": {},
    "animationIterationCount": {},
    "animationName": {},
    "animationPlayState": {},
    "animationTimingFunction": {},
    "appRegion": {},
    "appearance": {},
    "ascentOverride": {},
    "aspectRatio": {},
    "backdropFilter": {},
    "backfaceVisibility": {},
    "background": {},
    "backgroundAttachment": {},
    "backgroundBlendMode": {},
    "backgroundClip": {},
    "backgroundColor": {
        "type": "color"
    },
    "backgroundImage": {},
    "backgroundOrigin": {},
    "backgroundPosition": {},
    "backgroundPositionX": {},
    "backgroundPositionY": {},
    "backgroundRepeat": {},
    "backgroundRepeatX": {},
    "backgroundRepeatY": {},
    "backgroundSize": {},
    "basePalette": {},
    "baselineShift": {},
    "blockSize": {
        "type": "length"
    },
    "border": {},
    "borderBlock": {},
    "borderBlockColor": {
        "type": "color"
    },
    "borderBlockEnd": {},
    "borderBlockEndColor": {
        "type": "color"
    },
    "borderBlockEndStyle": {},
    "borderBlockEndWidth": {},
    "borderBlockStart": {},
    "borderBlockStartColor": {
        "type": "color"
    },
    "borderBlockStartStyle": {},
    "borderBlockStartWidth": {},
    "borderBlockStyle": {},
    "borderBlockWidth": {},
    "borderBottom": {},
    "borderBottomColor": {
        "type": "color"
    },
    "borderBottomLeftRadius": {},
    "borderBottomRightRadius": {},
    "borderBottomStyle": {},
    "borderBottomWidth": {},
    "borderCollapse": {},
    "borderColor": {
        "type": "color"
    },
    "borderEndEndRadius": {},
    "borderEndStartRadius": {},
    "borderImage": {},
    "borderImageOutset": {},
    "borderImageRepeat": {},
    "borderImageSlice": {},
    "borderImageSource": {},
    "borderImageWidth": {},
    "borderInline": {},
    "borderInlineColor": {
        "type": "color"
    },
    "borderInlineEnd": {},
    "borderInlineEndColor": {
        "type": "color"
    },
    "borderInlineEndStyle": {},
    "borderInlineEndWidth": {},
    "borderInlineStart": {},
    "borderInlineStartColor": {
        "type": "color"
    },
    "borderInlineStartStyle": {},
    "borderInlineStartWidth": {},
    "borderInlineStyle": {},
    "borderInlineWidth": {},
    "borderLeft": {},
    "borderLeftColor": {
        "type": "color"
    },
    "borderLeftStyle": {},
    "borderLeftWidth": {},
    "borderRadius": {},
    "borderRight": {},
    "borderRightColor": {
        "type": "color"
    },
    "borderRightStyle": {},
    "borderRightWidth": {},
    "borderSpacing": {},
    "borderStartEndRadius": {},
    "borderStartStartRadius": {},
    "borderStyle": {},
    "borderTop": {},
    "borderTopColor": {
        "type": "color"
    },
    "borderTopLeftRadius": {},
    "borderTopRightRadius": {},
    "borderTopStyle": {},
    "borderTopWidth": {},
    "borderWidth": {
        "type": "length",
        "values": [
            "medium",
            "thin",
            "thick"
        ]
    },
    "bottom": {
        "type": "length"
    },
    "boxShadow": {},
    "boxSizing": {
        "type": "list",
        "values": [
            "border-box",
            "content-box"
        ]
    },
    "breakAfter": {},
    "breakBefore": {},
    "breakInside": {},
    "bufferedRendering": {},
    "captionSide": {},
    "caretColor": {
        "type": "color"
    },
    "clear": {},
    "clip": {},
    "clipPath": {},
    "clipRule": {},
    "color": {
        "type": "color"
    },
    "colorInterpolation": {},
    "colorInterpolationFilters": {},
    "colorRendering": {},
    "colorScheme": {},
    "columnCount": {},
    "columnFill": {},
    "columnGap": {
        "type": "length"
    },
    "columnRule": {},
    "columnRuleColor": {
        "type": "color"
    },
    "columnRuleStyle": {},
    "columnRuleWidth": {},
    "columnSpan": {},
    "columnWidth": {},
    "columns": {},
    "contain": {},
    "containIntrinsicBlockSize": {},
    "containIntrinsicHeight": {},
    "containIntrinsicInlineSize": {},
    "containIntrinsicSize": {},
    "containIntrinsicWidth": {},
    "container": {},
    "containerName": {},
    "containerType": {},
    "content": {},
    "contentVisibility": {},
    "counterIncrement": {},
    "counterReset": {},
    "counterSet": {},
    "cursor": {},
    "cx": {},
    "cy": {},
    "d": {},
    "descentOverride": {},
    "direction": {},
    "display": {
        "type": "list",
        "values": [
            "block",
            "inline",
            "inline-block",
            "flex",
            "inline-flex",
            "contents",
            "grid",
            "inline-grid",
            "inline-table",
            "list-item",
            "run-in",
            "table",
            "table-caption",
            "table-column-group",
            "table-header-group",
            "table-footer-group",
            "tabl-row-group",
            "table-cell",
            "table-column",
            "table-row",
            "inherit",
            "initial",
            "none"
        ]
    },
    "dominantBaseline": {},
    "emptyCells": {},
    "fallback": {},
    "fill": {
        "type": "color"
    },
    "fillOpacity": {},
    "fillRule": {},
    "filter": {},
    "flex": {},
    "flexBasis": {
        "type": "length"
    },
    "flexDirection": {
        "type": "list",
        "values": [
            "row",
            "column",
            "row-reverse",
            "column-reverse"
        ]
    },
    "flexFlow": {},
    "flexGrow": {
        "type": "number"
    },
    "flexShrink": {
        "type": "number"
    },
    "flexWrap": {
        "type": "list",
        "values": [
            "nowrap",
            "wrap",
            "wrap-reverse"
        ]
    },
    "fieldSizing": {},
    "float": {
        "type": "list",
        "values": [
            "none",
            "left",
            "right",
            "inline-start",
            "inline-end"
        ]
    },
    "floodColor": {
        "type": "color"
    },
    "floodOpacity": {},
    "font": {},
    "fontDisplay": {},
    "fontFamily": {
        "type": "font"
    },
    "fontFeatureSettings": {},
    "fontKerning": {},
    "fontOpticalSizing": {},
    "fontPalette": {},
    "fontSize": {
        "type": "length"
    },
    "fontSizeAdjust": {},
    "fontStretch": {},
    "fontStyle": {},
    "fontSynthesis": {},
    "fontSynthesisSmallCaps": {},
    "fontSynthesisStyle": {},
    "fontSynthesisWeight": {},
    "fontVariant": {},
    "fontVariantCaps": {},
    "fontVariantEastAsian": {},
    "fontVariantLigatures": {},
    "fontVariantNumeric": {},
    "fontVariationSettings": {},
    "fontWeight": {},
    "forcedColorAdjust": {},
    "gap": {
        "type": "length"
    },
    "grid": {},
    "gridArea": {},
    "gridAutoColumns": {},
    "gridAutoFlow": {},
    "gridAutoRows": {},
    "gridColumn": {},
    "gridColumnEnd": {},
    "gridColumnGap": {
        "type": "length"
    },
    "gridColumnStart": {},
    "gridGap": {
        "type": "length"
    },
    "gridRow": {},
    "gridRowEnd": {},
    "gridRowGap": {
        "type": "length"
    },
    "gridRowStart": {},
    "gridTemplate": {},
    "gridTemplateAreas": {},
    "gridTemplateColumns": {},
    "gridTemplateRows": {},
    "height": {
        "type": "length"
    },
    "hyphenateCharacter": {},
    "hyphens": {},
    "imageOrientation": {},
    "imageRendering": {},
    "imageResolution": {
        "type": "resolution"
    },
    "inherits": {},
    "initialValue": {},
    "inlineSize": {
        "type": "length"
    },
    "inset": {},
    "insetBlock": {},
    "insetBlockEnd": {},
    "insetBlockStart": {},
    "insetInline": {},
    "insetInlineEnd": {},
    "insetInlineStart": {},
    "isolation": {},
    "justifyContent": {
        "type": "list",
        "values": [
            "start",
            "end",
            "flex-start",
            "flex-end",
            "self-start",
            "self-end",
            "center",
            "normal",
            "baseline",
            "first baseline",
            "last baseline",
            "space-between",
            "space-around",
            "space-evenly",
            "stretch",
            "safe",
            "unsafe"
        ]
    },
    "justifyItems": {
        "type": "list",
        "values": [
            "start",
            "end",
            "flex-start",
            "flex-end",
            "center",
            "normal",
            "baseline",
            "first baseline",
            "last baseline",
            "space-between",
            "space-around",
            "space-evenly",
            "stretch",
            "safe",
            "unsafe"
        ]
    },
    "justifySelf": {
        "type": "list",
        "values": [
            "start",
            "end",
            "flex-start",
            "flex-end",
            "self-start",
            "self-end",
            "center",
            "normal",
            "baseline",
            "first baseline",
            "last baseline",
            "space-between",
            "space-around",
            "space-evenly",
            "stretch",
            "safe",
            "unsafe"
        ]
    },
    "left": {
        "type": "length"
    },
    "letterSpacing": {
        "type": "length"
    },
    "lightingColor": {
        "type": "color"
    },
    "lineBreak": {},
    "lineGapOverride": {},
    "lineHeight": {
        "type": "length"
    },
    "listStyle": {},
    "listStyleImage": {},
    "listStylePosition": {},
    "listStyleType": {},
    "margin": {},
    "marginBlock": {},
    "marginBlockEnd": {
        "type": "length"
    },
    "marginBlockStart": {
        "type": "length"
    },
    "marginBottom": {
        "type": "length"
    },
    "marginInline": {},
    "marginInlineEnd": {
        "type": "length"
    },
    "marginInlineStart": {
        "type": "length"
    },
    "marginLeft": {
        "type": "length"
    },
    "marginRight": {
        "type": "length"
    },
    "marginTop": {
        "type": "length"
    },
    "marker": {},
    "markerEnd": {},
    "markerMid": {},
    "markerStart": {},
    "mask": {},
    "maskType": {},
    "maxBlockSize": {
        "type": "length"
    },
    "maxHeight": {
        "type": "length"
    },
    "maxInlineSize": {
        "type": "length"
    },
    "maxWidth": {
        "type": "length"
    },
    "minBlockSize": {
        "type": "length"
    },
    "minHeight": {
        "type": "length"
    },
    "minInlineSize": {
        "type": "length"
    },
    "minWidth": {
        "type": "length"
    },
    "mixBlendMode": {},
    "negative": {},
    "objectFit": {},
    "objectPosition": {
        "type": "position"
    },
    "objectViewBox": {},
    "offset": {},
    "offsetDistance": {},
    "offsetPath": {},
    "offsetRotate": {
        "type": "angle"
    },
    "opacity": {
        "type": "number"
    },
    "order": {},
    "orphans": {},
    "outline": {},
    "outlineColor": {
        "type": "color"
    },
    "outlineOffset": {
        "type": "length"
    },
    "outlineStyle": {},
    "outlineWidth": {
        "type": "length",
        "values": [
            "medium",
            "thin",
            "thick"
        ]
    },
    "overflow": {
        "type": "list",
        "values": [
            "visible",
            "hidden",
            "clip",
            "scroll",
            "auto"
        ]
    },
    "overflowAnchor": {},
    "overflowClipMargin": {},
    "overflowWrap": {},
    "overflowX": {
        "type": "list",
        "values": [
            "visible",
            "hidden",
            "clip",
            "scroll",
            "auto"
        ]
    },
    "overflowY": {
        "type": "list",
        "values": [
            "visible",
            "hidden",
            "clip",
            "scroll",
            "auto"
        ]
    },
    "overrideColors": {},
    "overscrollBehavior": {},
    "overscrollBehaviorBlock": {},
    "overscrollBehaviorInline": {},
    "overscrollBehaviorX": {},
    "overscrollBehaviorY": {},
    "pad": {},
    "padding": {},
    "paddingBlock": {},
    "paddingBlockEnd": {},
    "paddingBlockStart": {},
    "paddingBottom": {},
    "paddingInline": {},
    "paddingInlineEnd": {},
    "paddingInlineStart": {},
    "paddingLeft": {},
    "paddingRight": {},
    "paddingTop": {},
    "page": {},
    "pageBreakAfter": {},
    "pageBreakBefore": {},
    "pageBreakInside": {},
    "pageOrientation": {},
    "paintOrder": {},
    "perspective": {
        "type": "length"
    },
    "perspectiveOrigin": {},
    "placeContent": {},
    "placeItems": {},
    "placeSelf": {},
    "pointerEvents": {},
    "position": {
        "type": "list",
        "values": [
            "static",
            "relative",
            "absolute",
            "fixed",
            "sticky"
        ]
    },
    "prefix": {},
    "quotes": {},
    "r": {},
    "range": {},
    "resize": {},
    "right": {
        "type": "length"
    },
    "rotate": {
        "type": "angle"
    },
    "rowGap": {
        "type": "length"
    },
    "rubyAlign": {},
    "rubyPosition": {},
    "rx": {},
    "ry": {},
    "scale": {
        "type": "scale"
    },
    "scrollbarColor": {},
    "scrollbarGutter": {
        "type": "list",
        "values": [
            "auto",
            "stable",
            "stable both-edges"
        ]
    },
    "scrollbarWidth": {},
    "scrollBehavior": {},
    "scrollMargin": {},
    "scrollMarginBlock": {},
    "scrollMarginBlockEnd": {},
    "scrollMarginBlockStart": {},
    "scrollMarginBottom": {},
    "scrollMarginInline": {},
    "scrollMarginInlineEnd": {},
    "scrollMarginInlineStart": {},
    "scrollMarginLeft": {},
    "scrollMarginRight": {},
    "scrollMarginTop": {},
    "scrollPadding": {},
    "scrollPaddingBlock": {},
    "scrollPaddingBlockEnd": {},
    "scrollPaddingBlockStart": {},
    "scrollPaddingBottom": {},
    "scrollPaddingInline": {},
    "scrollPaddingInlineEnd": {},
    "scrollPaddingInlineStart": {},
    "scrollPaddingLeft": {},
    "scrollPaddingRight": {},
    "scrollPaddingTop": {},
    "scrollSnapAlign": {},
    "scrollSnapStop": {},
    "scrollSnapType": {},
    "shapeImageThreshold": {},
    "shapeMargin": {},
    "shapeOutside": {},
    "shapeRendering": {
        "type": "list",
        "values": [
            "auto",
            "optimizeSpeed",
            "crispEdges",
            "geometricPrecision"
        ]
    },
    "size": {},
    "sizeAdjust": {},
    "speak": {},
    "speakAs": {},
    "src": {},
    "stopColor": {
        "type": "color"
    },
    "stopOpacity": {},
    "stroke": {
        "type": "color"
    },
    "strokeDasharray": {},
    "strokeDashoffset": {},
    "strokeLinecap": {},
    "strokeLinejoin": {},
    "strokeMiterlimit": {},
    "strokeOpacity": {},
    "strokeWidth": {
        "type": "number"
    },
    "suffix": {},
    "symbols": {},
    "syntax": {},
    "system": {},
    "tabSize": {},
    "tableLayout": {},
    "textAlign": {
        "type": "list",
        "values": [
            "start",
            "end",
            "left",
            "right",
            "center",
            "justify",
            "justify-all",
            "match-parent"
        ]
    },
    "textAlignLast": {},
    "textAnchor": {},
    "textCombineUpright": {},
    "textDecoration": {},
    "textDecorationColor": {
        "type": "color"
    },
    "textDecorationLine": {},
    "textDecorationSkipInk": {},
    "textDecorationStyle": {},
    "textDecorationThickness": {},
    "textEmphasis": {},
    "textEmphasisColor": {
        "type": "color"
    },
    "textEmphasisPosition": {},
    "textEmphasisStyle": {},
    "textIndent": {
        "type": "length"
    },
    "textOrientation": {},
    "textOverflow": {},
    "textRendering": {},
    "textShadow": {},
    "textSizeAdjust": {},
    "textTransform": {},
    "textUnderlineOffset": {},
    "textUnderlinePosition": {},
    "textWrap": {},
    "textWrapMode": {
        "type": "list",
        "values": [
            "wrap",
            "nowrap"
        ]
    },
    "textWrapStyle": {
        "type": "list",
        "values": [
            "auto",
            "balance",
            "pretty",
            "stable"
        ]
    },
    "top": {
        "type": "length"
    },
    "touchAction": {},
    "transform": {},
    "transformBox": {},
    "transformOrigin": {},
    "transformStyle": {},
    "transition": {},
    "transitionDelay": {
        "type": "time"
    },
    "transitionBehavior": {},
    "transitionDuration": {
        "type": "time"
    },
    "transitionProperty": {},
    "transitionTimingFunction": {},
    "translate": {},
    "unicodeBidi": {},
    "unicodeRange": {},
    "userSelect": {},
    "vectorEffect": {},
    "verticalAlign": {},
    "visibility": {},
    "whiteSpace": {},
    "widows": {},
    "width": {
        "type": "length"
    },
    "willChange": {},
    "wordBreak": {},
    "wordSpacing": {
        "type": "length"
    },
    "wordWrap": {},
    "writingMode": {},
    "x": {},
    "y": {},
    "zIndex": {},
    "zoom": {
        "type": "scale"
    }
}
